import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { commonCss } from "../StyleConfig/CommonCss";

const WarningConfirmation = ({ message, onSubmit, handleCloseClick }) => {
  const [focusedButton, setFocusedButton] = useState("yes");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const yesButtonRef = useRef(null);
  const noButtonRef = useRef(null);

  useEffect(() => {
    if (yesButtonRef.current) {
      yesButtonRef.current.focus();
    }
  }, []);

  const handleSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    onSubmit();
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowLeft":
        setFocusedButton("yes");
        yesButtonRef.current?.focus();
        break;
      case "ArrowRight":
        setFocusedButton("no");
        noButtonRef.current?.focus();
        break;
      case "Enter":
        e.preventDefault();
        if (focusedButton === "yes") {
          handleSubmit();
        } else {
          handleCloseClick();
        }
        break;
      default:
        break;
    }
  };

  return (
    <Grid2 container spacing={2} onKeyDown={handleKeyDown} tabIndex={-1}>
      <Grid2 size={12} container justifyContent={"center"}>
        <Typography
          fontWeight={400}
          color="white"
          sx={{ fontSize: "1rem", textAlign: "center" }}
        >
          {message}
        </Typography>
      </Grid2>
      <Grid2 size={12} container justifyContent={"center"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.6rem",
          }}
        >
          <Button
            ref={yesButtonRef}
            type="button"
            variant="contained"
            disabled={isSubmitting}
            sx={{
              backgroundColor: commonCss.blue,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              "&:focus": {
                outline: "2px solid #fff",
                outlineOffset: "2px",
              },
              "&:disabled": {
                opacity: 0.7,
                cursor: "not-allowed",
              },
            }}
            onClick={handleSubmit}
            onFocus={() => setFocusedButton("yes")}
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
          >
            {isSubmitting ? "Processing..." : "Yes"}
          </Button>
          <Button
            ref={noButtonRef}
            type="button"
            variant="contained"
            sx={{
              backgroundColor: commonCss.blue,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              "&:focus": {
                outline: "2px solid #fff",
                outlineOffset: "2px",
              },
            }}
            onClick={handleCloseClick}
            onFocus={() => setFocusedButton("no")}
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
          >
            No
          </Button>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default WarningConfirmation;
